import { UserStatusType } from '@pt/models';

export enum SortOptions {
  nameAsc = 'menteeName',
  nameDesc = '-menteeName',
  probationEndAsc = 'menteeProbationEnd',
  probationEndDesc = '-menteeProbationEnd',
  seniorityAsc = 'menteeSeniority',
  seniorityDesc = '-menteeSeniority',
  statusAsc = 'menteeStatus',
  statusDesc = '-menteeStatus',
  mentoringPlanNameAsc = 'mentoringPlanName',
  mentoringPlanNameDesc = '-mentoringPlanName',
}

export type MenteeStatus = Omit<UserStatusType, 'offboarding'>;

export enum MentoringPlanStatus {
  Finished = 'finished',
  InProgress = 'inProgress',
  NotStarted = 'notStarted',
  NotAssigned = 'notAssigned',
}

export interface FiltersBase {
  page: number;
  limit: number;
  sort: SortOptions;
  searchMentee: string | null;
  menteeStatus: MenteeStatus | null;
  mentoringPlanStatus: MentoringPlanStatus | null;
}

export interface MenteeFilters extends FiltersBase {
  sort: SortOptions;
}
